"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Label_1 = require("components/Label");
var DatePicker_1 = require("components/DatePicker");
var mobx_1 = require("mobx");
var dateToString_1 = require("lib/functions/dateToString");
var Signature_1 = require("components/Signature");
var findErrors_1 = require("lib/functions/findErrors");
var mobx_react_1 = require("mobx-react");
var rules = {
    signature: { presence: { allowEmpty: false, message: "is required" } }
};
var SignatureBox = (function (_super) {
    __extends(SignatureBox, _super);
    function SignatureBox(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.json_data.date = dateToString_1.jsDateToMySQLDate(new Date());
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    SignatureBox.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    SignatureBox.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("validateSignature", this.isValid);
                return [2];
            });
        });
    };
    SignatureBox.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("validateSignature");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    SignatureBox.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    SignatureBox.prototype.isValid = function () {
        console.log("Validate Signature");
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Signature errors", this.errors);
        return isValid;
    };
    SignatureBox.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "Disclaimer and Signature"),
            React.createElement("h3", { className: "sub-title" }, "In connection with my application to the Academy for Nursing and Health Occupations, I understand that a consumer report, which may contain public records information is being requested"),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-xs-6" },
                    React.createElement(Signature_1.Signature, { id: "signature", onChange: this.onChange, model: this.props.model, errors: this.errors, title: "Signature" })),
                React.createElement("div", { className: "col-xs-6" },
                    React.createElement(Label_1.Label, { htmlFor: "date", text: "Date", required: true }),
                    React.createElement(DatePicker_1.DatePicker, { id: "date", json_data: json_data, onChange: onChange, errors: errors, disabled: true })))));
    };
    __decorate([
        mobx_1.observable
    ], SignatureBox.prototype, "errors", void 0);
    SignatureBox = __decorate([
        mobx_react_1.observer
    ], SignatureBox);
    return SignatureBox;
}(react_1.Component));
exports.SignatureBox = SignatureBox;
//# sourceMappingURL=data:application/json;base64,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